import script from "./RfidProcessingOrderPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RfidProcessingOrderPage.vue?vue&type=script&setup=true&lang=js"

import "./RfidProcessingOrderPage.vue?vue&type=style&index=0&id=3f2bafde&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f2bafde"]])

export default __exports__